import styled, { css } from 'styled-components';
import boardSrc from 'assets/images/board.min.png';
import boardLow from 'assets/images/boardLow.min.png';

export const SWrapper = styled.div<{ isPlaying: boolean }>`
  position: relative;
  padding: 65px 20px 60px;
  background-color: #4d0000;
  background-image: url('${boardSrc}');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: top;
  border-radius: 5px;
  user-select: none;

  &:after {
    content: '';
    display: block;
    position: absolute;
    width: calc(100% + 110px);
    left: -55px;
    bottom: 0;
    height: 50px;
    background-image: url('${boardLow}');
    background-size: 100% auto;
    background-repeat: no-repeat;
  }

  @media (max-width: 990px) and (max-aspect-ratio: 1/1) {
    padding: 60px 20px 34px;

    &:after {
      display: none;
    }
  }

  @media (max-width: 600px) and (max-aspect-ratio: 1/1) {
    padding: 55px 20px 34px;
  }

  @media (max-width: 520px) and (max-aspect-ratio: 1/1) {
    padding: 40px 15px 34px;
  }

  @media (max-width: 450px) and (max-aspect-ratio: 1/1) {
    padding: 30px 10px 30px;
  }

  @media (max-width: 400px) and (max-aspect-ratio: 1/1) {
    padding: 30px 10px 20px;
  }

  @media (max-width: 320px) and (max-aspect-ratio: 1/1) {
    padding: 30px 10px 15px;
  }
`;

export const SInner = styled.div<{
  disabled: boolean;
  cellAnimDelay: string;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}

  ${({ cellAnimDelay }) => cellAnimDelay}
`;
